import {
  CLOSURE,
  DIRECTION,
  DISPLAY_STATUS,
  OBSERVATION_STATUS,
  OBSERVATION_TYPE,
} from "../../../utils/constants/observations";
import { fullName } from "../../../utils/helpers/userDisplay";
import { formatMonthShort, formatShortDate } from "../../../utils/helpers/dateDisplay";

export const decorateUpcoming = (apiObs, currentUserUuid) => {
  const direction =
    apiObs.observed_teacher?.uuid === currentUserUuid
      ? DIRECTION.INCOMING
      : DIRECTION.OUTGOING;

  let displayStatus;
  if (apiObs.status === OBSERVATION_STATUS.CANCELLED) {
    // The observed teacher rejecting = "Declined"; the requester/manager
    // withdrawing = "Cancelled". Falls back to declined for legacy rows.
    displayStatus =
      apiObs.closure === CLOSURE.CANCELLED
        ? DISPLAY_STATUS.CANCELLED
        : DISPLAY_STATUS.DECLINED;
  } else if (apiObs.confirmed_at) {
    displayStatus = DISPLAY_STATUS.CONFIRMED;
  } else if (apiObs.type === OBSERVATION_TYPE.PEER) {
    // An unconfirmed peer visit is pending SOMEONE's decision: the observed
    // teacher's if it's incoming (they confirm/decline), or the requester is
    // awaiting the peer if it's outgoing. Never show "Confirmed" before the
    // peer has actually accepted.
    displayStatus =
      direction === DIRECTION.INCOMING
        ? DISPLAY_STATUS.PENDING
        : DISPLAY_STATUS.AWAITING;
  } else {
    // Official/self visits carry no confirmation step — they are simply
    // scheduled, not "confirmed".
    displayStatus = DISPLAY_STATUS.SCHEDULED;
  }

  const counterparty =
    direction === DIRECTION.INCOMING
      ? apiObs.main_observer
      : apiObs.observed_teacher;

  const scheduledDate = apiObs.scheduled_date
    ? new Date(apiObs.scheduled_date)
    : null;

  return {
    ...apiObs,
    direction,
    displayStatus,
    // The requester's note. Legacy scheduled rows stored it in lesson_topic
    // before it moved to general_comment — surface either as the note.
    noteText: apiObs.general_comment || apiObs.lesson_topic || "",
    counterparty: counterparty || null,
    counterpartyName: counterparty ? fullName(counterparty) : "—",
    dateLabel: formatShortDate(apiObs.scheduled_date),
    monthShort: scheduledDate ? formatMonthShort(scheduledDate) : "",
    dayNum: scheduledDate ? scheduledDate.getDate() : "",
  };
};
